import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';
import stateData from '../../shared/states.json';
import { Location } from '@angular/common';
import { License, LicenseResolved, newLicense, LicenseOcc } from '../license';
import { AuthService } from '../../users/auth.service';
import { HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { Enum } from '../enum';
import { User } from 'src/app/users/user';
import { Validator } from '../../shared/validator';
import { Title } from "@angular/platform-browser";
import { Authority } from 'src/app/authorities/authority';
import { EditGuard } from 'src/app/shared/edit.guard';

@Component({
    selector: 'pm-license-edit.detail',
    templateUrl: './license-edit.component.html',
    styleUrls: ['./license-edit.component.scss'],
    standalone: false
})
export class LicenseEditComponent implements OnInit{
   
  authorities;
  enum: Enum[];
  coordinator: User;
  socSearchTerms: string='';
  occcodes:string[]=[];
  states=[];
  licList: number[];
  licListPtr: number;
  relLicSelection: any[];
  filteredRelLicItems: any[];
  filteredStates: any[];
  filteredOccs: any[];
  dataIsValid;                     // To delete;
  errorMessage: string;
  isAllowedName: boolean;
  showDepartmentSearchBox: boolean;
  showSocSearchBox: boolean;
  enumFields=[
    {name: 'edu', col: 'education', label: 'Education:', sel: '--Please select'},
    {name: 'cert', col: 'certification', label: 'Certification:', sel: '--Please select'},
    {name: 'cedu', col: 'continuingedu', label: 'Continuing Education:', sel: '--Please select'},
    {name: 'exp', col: 'experience', label: 'Experience:', sel: '--Please select'},
    {name: 'exam', col: 'exam', label: 'Exam:', sel: '--Please select'},
    {name: 'crim', col: 'criminal', label: 'Criminal:', sel: '--Please select'},
    {name: 'phy', col: 'physical', label: 'Physical Requirements:', sel: '--Please select'},
    {name: 'vet', col: 'veteran', label: 'Veteran:', sel: '--Please select'},
    {name: 'active', col: 'inactive', label: 'Active status:', sel: '--Please select'},
    {name: 'types', col: 'licenseType', label: 'License Type:', sel: '--Please select'},
   ];

  feeFields=[
     {name: 'applicationFee', label: 'Application fee', prop: 'applicationfee'},
   ];
  numDepts: any;
     
  // https://stackoverflow.com/questions/54889941/how-to-use-math-min-or-math-max-syntax-in-angular-template
  get math() {
    return Math;
  }

  currentLicense:License;
  originalLicense:License;
  get license():License {
    return this.currentLicense;
  }
  set license(value:License) {
    this.currentLicense = value;
    // Clone the object to retain a copy
    this.originalLicense = value ? { ...value } : null;
  }

  get isDirty(): boolean {
    return JSON.stringify(this.originalLicense) !== JSON.stringify(this.currentLicense);
  }

  isValid(path?: string): boolean {
    if (path) {
      return this.dataIsValid[path];
    }
    return (this.dataIsValid &&
      Object.keys(this.dataIsValid).every(d => this.dataIsValid[d] === true));
  }

  get issuedYr(): number {
    const curDate=new Date();
    return curDate.getFullYear()-(curDate.getMonth()<2?3:2);
  }

  constructor(private dataService: DataService, public auth: AuthService, private route: ActivatedRoute, 
      private router: Router, private _location: Location, public v: Validator, private title: Title, private editGuard: EditGuard) { }

  ngOnInit() { 
    this.route.params.subscribe(
      params => {
          const id = +params['id'];
          this.getLicense(id);
      }
    );
/////////////////////////////////////////////
    this.dataService.getAllLicenses().subscribe((x)=>this.relLicSelection=x.map((y)=> {return{display: y.licTitle, value: y.id.toString() };}));
    let list=sessionStorage.getItem('liclist');
    if (list){      
      this.licList=JSON.parse(list);
     }
    this.dataService.getEnum().subscribe((data: Enum[])=>{
      this.enum=data;
    });
    this.states.push('Nationwide');
    stateData.forEach(s=>{if(s.abbrev!=='NC') this.states.push(s.abbrev)});
    if (this.auth.isLeadAdmin) {
      this.dataService.getSoccodes().subscribe((data)=>{
          data.forEach(s => {this.occcodes.push(s.socCode+' '+s.socTitle)
       });
      })
  //    console.log(this.occcodes);
    }
  }

  filterStates(event: any) 
  {
    const query = event.query.toLowerCase();
    this.filteredStates = this.states.filter(state => 
        state.toLowerCase().includes(query));
  }

  filterRelLicenses(event:any)
  {
    // [innerHTML]="resource.title | highlight: this.searchTerms" Todo: Highlight pipe
    const query = event.query.toLowerCase(); 
    this.filteredRelLicItems = this.relLicSelection.filter(item => 
      item.display.toLowerCase().includes(query));
  }

  filterOccupations(event:any)
  {
    // [innerHTML]="resource.title | highlight: this.searchTerms" Todo: Highlight pipe
    // console.log(this.occcodes);
    const query = event.query.toLowerCase(); 
    this.filteredOccs = this.occcodes.filter(item => 
      item.toLowerCase().includes(query));
  }
  getLicense(id:number)
  {    
    this.dataService.getAllAuthorities().subscribe(data=>{
      this.authorities=data;      
      this.authorities.forEach(a=>a.name=a.department+(a.division!==''?'/':'')+a.division+(a.board!==''?'/':'')+a.board);
       if (id==0){
        this.license=newLicense();
        this.license.licAuthId=(this.authorities[0].id+1000).toString().substr(1);
        this.license.department=this.authorities[0].name;
        this.license.coord=this.authorities[0].coord;
        this.isAllowedName=true;
        this.license=this.license;
      }
      else {
        this.dataService.getLicense(id).subscribe((data: License)=>{
          this.license = data;
          console.log(this.license);
          if (!this.license)
            this.router.navigateByUrl('/**');
          this.title.setTitle(`Editing ${this.license.licTitle}`);
          // TODO: Workaround code - combined auth name temporarily resides in department 02/11/20
          this.license.department=this.license.department+(this.license.division!==''?'/':'')+this.license.division+(this.license.board!==''?'/':'')+this.license.board;
          this.license.recipStates=[];
          if (this.license.reciprocity)
            this.license.reciprocity.split(',').forEach(x=>this.license.recipStates.push(x));
          this.license.tagList=[];
          if (this.license.keywords)
            this.license.keywords.split('~').forEach(x=>this.license.tagList.push(x));      
          this.licListPtr=this.licList.findIndex(x=>x===id);
          this.isAllowedName=true;
          if (this.license.occs){ 
            this.license.occsSelected=[];
            this.license.occs.forEach(o=>{this.license.occsSelected.push(o.occCode+' '+o.occTitle);});
          }
          this.originalLicense=JSON.parse(JSON.stringify(this.license));
       });
      }
    });    
  }

  @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean { 
        if (this.editGuard.bypassMe)
          return true;
        return !this.isDirty;
    }

  @ViewChild('licForm', {static: false}) licenseForm: any;   

  setAuthid(id: number) {
    this.dataService.getAuthority(id).subscribe((data: Authority)=>{
      let authority=data;
      if (!authority)
        return false;
      this.license.licAuthId=(1000+id).toString().substring(1);
      this.license.department=authority.department;
      this.license.authPhone=authority.telephone;
      this.license.authExt=authority.teleExt;
      this.license.authEmail=authority.email;
      this.license.url=authority.url;
      this.license.contact=authority.contact;
      this.license.coord=authority.coord;
    })
    this.showDepartmentSearchBox=false;
    this.isAllowedName=true;
    return false;
  }

  resetAuthid(event) {
    if (event.key=='Escape')
      this.setAuthid(+this.license.licAuthId);
  }

  filterEnum (name: string){
    return this.enum.filter(e=>e.name==name);
  }

  filterSocResults (occ: any){
    const terms=this.socSearchTerms.split(' ');
    return terms.every((term)=>{if (term.length==0) return true;
      let re=new RegExp(term, 'gi'); return occ.socCode.match(re) || occ.socTitle.match(re);});    
  }

  coordOnlyValidation(){
    this.licenseForm.controls['licNum'].setErrors(typeof(this.license.licNum)==='object'?{'incorrect': true}:null);
    this.licenseForm.controls['duration'].setErrors(!this.license.duration?{'incorrect': true}:null);
    this.licenseForm.controls['authority'].setErrors(!this.license.authority?{'incorrect': true}:null);
  }

  update():void {
  //  console.log(this.license.relLicsSelected);
    if (this.auth.isCoordinator)
      this.coordOnlyValidation();
    if (+this.license.licNum<0){
      this.licenseForm.controls['licNum'].setErrors({'incorrect': true});
    }
    var t=this;
    var fees = ["newLicFee","applicationFee","renewalFee","miscFee","ricipFee"];
    fees.forEach(
      function(fee){
      if (+t.license[fee]<0 || +t.license[fee] >= 1000000){
        t.licenseForm.controls[fee].setErrors({'incorrect': true});

      }});
    if (this.v.validate(this.licenseForm)){
      if (this.license.tagList){
        this.license.keywords=this.license.tagList.map(k=>!k.display?k:k.display).join('~');
      }
      if (this.license.occsSelected.length>0)
      {
        this.license.occs=[];
        // console.log(this.license.occsSelected);
        this.license.occsSelected.forEach(o=>{
          this.license.occs.push({
            occCode: o.substring(0,7),
            occTitle: null,
            occDesc: null,
            hasOccProfile: null});          
        });
      } 
      if (this.license.recipStates){
        this.license.reciprocity=this.license.recipStates.join(',');     
      }
      let statusChange=(this.currentLicense.inactive!==this.originalLicense.inactive) ||
                      (this.currentLicense.licAuthId!==this.originalLicense.licAuthId);   // Moved from one authority to another
      this.dataService.updateLicense(this.license, statusChange).subscribe((data: number)=>{
        this.license.id=data;
        this.license=this.license; 
      });
    }
  }

  hideSearchBoxes(){
    this.showDepartmentSearchBox=false;
  }

  authorityBoxIn(){
    this.showDepartmentSearchBox=true;
  }

  filterAuthority (name: any){
    const terms=this.license.department.split(' ');
    return terms.every((term)=>{if (term.length==0) return true;
      let re=new RegExp(term, 'gi'); return name.match(re);}); 
  }


  
  validateName(){
//    console.log('validateName',this.authorities, this.license.department);
    this.isAllowedName=!!this.authorities.find(f=>f.name==this.license.department);
    //console.log('In validate name', this.isAllowedName, this.license, a);
  }

  goBack() {
    this._location.back();
  }  
}